import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, subDays } from "date-fns"; 
import MonthKey from "./MonthKey";
import MonthAllocation from "./MonthAllocation";
import MonthPolicy from "./MonthPolicy";
import MonthFPS from "./MonthFPS";
import LessCardsFPS from "./LessCardsFPS";
import rightImg from "../../images/right.png";
import wrongImg from "../../images/wrong.png";
import CircularProgress from '@mui/material/CircularProgress';

function Month_status() {
   const [status, setStatus] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentView, setCurrentView] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
      setLoading(true);
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_URL}/api/distribution/month_status`
    );
    setStatus(res.data);
    setStartDate(res.data.curDate);
    setEndDate(res.data.curDate);
  } catch (err) {
      console.error(err);
      if (err.response && err.response.data) {
        alert("Error: " + err.response.data);
      } else {
        alert("Invalid Exception");
      }
    } finally {
      setLoading(false); 
    }
  };

 const fetchViewData = async (viewType) => {
  setViewLoading(true);
  setCurrentView(viewType);
  try {
    let endpoint = "";
    switch(viewType) {
      case "keyregister":
        endpoint = "month_key";
        break;
      case "allocation":
        endpoint = "month_allocation";
        break;
      case "policy":
        endpoint = "month_policy";
        break;
      case "fps":
        endpoint = "month_fps";
        break;
      case "lesscards":
        endpoint = "less_cards_shops";
        break;
      default:
        endpoint = "month_key";
    }
    const res = await axios.get(
      `${process.env.REACT_APP_URL}/api/distribution/${endpoint}`
    );
    
    if (typeof res.data === 'string') {
      setViewData([]);
      alert(res.data);
    } else {
      setViewData(res.data);
    }
  } catch (err) {
    console.error(err);
    if (err.response && err.response.data) {
      alert("Invalid Exception: " + err.response.data);
    } else {
      alert("Invalid Exception");
    }
    setViewData([]);
  } finally {
    setViewLoading(false);
  }
};

  const startDistribution = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/distribution/start_distribution`,
        null,
        {
          params: {
            month: status.month,
            year: status.year,
            startDate: startDate,
            endDate: endDate
          }
        }
      );
      alert(response.data);
      fetchStatus();
    } catch (err) {
      console.error(err);
      alert("Distribution start failed: " + (err.response?.data || err.message));
    } finally {
      setLoading(false);
    }
  };

  const formatDateToDDMMYYYY = (date) => {
    if (!date) return "";
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const parseDDMMYYYYToDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      return new Date(parts[2], parts[1] - 1, parts[0]); 
    }
    return null;
  };
  const handleStartDateChange = (date) => {
    setStartDate(formatDateToDDMMYYYY(date));
  };

  const handleEndDateChange = (date) => {
    setEndDate(formatDateToDDMMYYYY(date));
  };

  const handleEndDateMouseOver = (e) => {
    e.target.select();
  };

   const renderCurrentView = () => {
    if (viewLoading) {
      return (
        <div align="center" style={{ padding: '20px' }}>
          <CircularProgress />
        </div>
      );
    }
    switch(currentView) {
      case "keyregister":
        return <MonthKey data={viewData} monthName={status.monthName} year={status.year} />;
      case "allocation":
        return <MonthAllocation data={viewData} monthName={status.monthName} year={status.year} />;
      case "policy":
        return <MonthPolicy data={viewData} monthName={status.monthName} year={status.year} />;
      case "fps":
        return <MonthFPS data={viewData} monthName={status.monthName} year={status.year} />;
      case "lesscards":
        return <LessCardsFPS data={viewData} monthName={status.monthName} year={status.year} check={status.check} />;
      default:
        return null;
    }
  };

  if (!status || !status.year) return <div align="center" id="loading" style={{ display: loading ? 'block' : 'none' }}>
            <CircularProgress />
          </div>;

  let butCheck = 0;
  let msg = "";
  if (status.fpsCheck > 0) {
    butCheck = butCheck + 1;
  } else {
    msg = msg + "Key Register Not Generated.<br/>";
  }
  if (status.allocationCheck > 0) {
    butCheck = butCheck + 1;
  } else {
    msg = msg + "Allocation Not Generated.<br/>";
  }
  if (status.policyCheck > 0) {
    butCheck = butCheck + 1;
  } else {
    msg = msg + "Policy Not Entered.<br/>";
  }
  if (status.statusCheck > 0) {
 
  } else {
    butCheck = butCheck + 1;
  }
  if (status.lessCards > 0) {
 
  } else {
    butCheck = butCheck + 1;
  }

  return (
    <div style={{ paddingBottom: '70px' }}>
      {status.year > 0 && (
        <>
          <table border="1" width="38%" align="center">
            <thead>
              <tr className="tableheader">
                <th colSpan="3">
                  Month Status for{" "}
                  <font style={{ color: "orange" }}>
                    {status.monthName} '{status.year}
                  </font>
                </th>
              </tr>
              <tr className="tableheader">
                <th>Sl.No</th>
                <th>Type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => fetchViewData("keyregister")}
                  >
                    Key Register
                  </a>
                </td>
                <td align="center">
                  {status.fpsCheck > 0 ? (
                    <img height="20px" width="20px" alt="Right" src={rightImg} />
                  ) : (
                    <img height="20px" width="20px" alt="Wrong" src={wrongImg} />
                  )}
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => fetchViewData("allocation")}
                  >
                    Allocation
                  </a>
                </td>
                <td align="center">
                  {status.allocationCheck > 0 ? (
                    <img height="20px" width="20px" alt="Right" src={rightImg} />
                  ) : (
                    <img height="20px" width="20px" alt="Wrong" src={wrongImg} />
                  )}
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => fetchViewData("policy")}
                  >
                    Rate Master
                  </a>
                </td>
                <td align="center">
                  {status.policyCheck > 0 ? (
                    <img height="20px" width="20px" alt="Right" src={rightImg} />
                  ) : (
                    <img height="20px" width="20px" alt="Wrong" src={wrongImg} />
                  )}
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => fetchViewData("fps")}
                  >
                    FPS Status
                  </a>
                </td>
                <td align="center">
                  {status.statusCheck > 0 ? (
                    <img height="20px" width="20px" alt="Wrong" src={wrongImg} />
                  ) : (
                    <img height="20px" width="20px" alt="Right" src={rightImg} />
                  )}
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => fetchViewData("lesscards")}
                  >
                    Below {status.check} Cards FPS
                  </a>
                </td>
                <td align="center">
                  {status.lessCards > 0 ? (
                    <img height="20px" width="20px" alt="Wrong" src={wrongImg} />
                  ) : (
                    <img height="20px" width="20px" alt="Right" src={rightImg} />
                  )}
                </td>
              </tr>
              {status.dcheck > 0 ? (
                <tr>
                  <td colSpan="3">
                    <div align="center">Distribution is in Progress</div>
                  </td>
                </tr>
              ) : butCheck === 4 ? (
                <>
                  <tr>
                    <td colSpan="3">
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'nowrap', gap: '10px' }}>
                        <span>Start Date:</span>
                        <DatePicker
                          ref={startDateRef}
                          selected={parseDDMMYYYYToDate(startDate)}
                          onChange={handleStartDateChange}
                          minDate={new Date()} 
                          maxDate={addDays(new Date(), 15)} 
                          dateFormat="dd-MM-yyyy" 
                          autoComplete="off"
                          className="custom-datepicker" 
                          wrapperClassName="custom-datepicker-wrapper"
                        />
                        <span>End Date:</span>
                        <DatePicker
                          ref={endDateRef}
                          selected={parseDDMMYYYYToDate(endDate)}
                          onChange={handleEndDateChange}
                          minDate={subDays(new Date(), 20)} 
                          maxDate={addDays(new Date(), 30)} 
                          dateFormat="dd-MM-yyyy" 
                          autoComplete="off"
                          onMouseEnter={handleEndDateMouseOver} 
                          className="custom-datepicker" 
                          wrapperClassName="custom-datepicker-wrapper"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3">
                      <div align="center">
                        <button 
  onClick={startDistribution} 
  className="button button2" 
  disabled={loading}
>
  Start Distribution
</button>

                      </div>
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan="3">
                    <div align="left" dangerouslySetInnerHTML={{ __html: msg }} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <br />

{loading && (
  <div align="center" style={{ marginTop: "15px" }}>
    <CircularProgress />
  </div>
)}


          <br />
          <div id="detailsR">
            {renderCurrentView()}
          </div>
        </>
      )}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        style={{
          position: 'fixed',
          right: '18px',
          bottom: '18px',
          zIndex: 9999,
          backgroundColor: '#f1872bff',
          color: '#100d0dff',
          border: 'none',
          padding: '12px 14px',
          borderRadius: '20px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          cursor: 'pointer'
        }}
        title="Back to Top"
      >
        Top
      </button>
      <style jsx>{`
        .custom-datepicker-wrapper {
          display: inline-block;
          margin: 0 5px;
        }
        .custom-datepicker {
          background-color: #ffa366 !important; /* Exact original style */
          border: 1px solid #ccc;
          padding: 5px;
          font-size: 14px;
          width: 120px; /* Fixed width for consistent alignment */
        }
        .custom-datepicker:focus {
          outline: none;
          border-color: #007cba;
        }
        .react-datepicker-wrapper {
          display: inline-block;
          padding: 0;
          border: 0;
          width: auto;
        }
        .react-datepicker__input-container input {
          background-color: hsla(24, 100%, 70%, 1.00) !important; /* Ensure background */
          width: 100%;
        }
      `}</style>
    </div>
  );
}

export default Month_status;